import * as React from 'react';
import type { IHamburgerMenuContainerProps } from '../../../HamburgerMenuContainer.props';
import HamburgerMenuContainerCommon from '../../HamburgerMenuContainer';
import styles from '../../HamburgerMenuContainer.module.scss';

const HamburgerMenuContainerSkin: React.FC<
  IHamburgerMenuContainerProps
> = props => {
  return (
    <HamburgerMenuContainerCommon {...props} rootClassName={styles.root} />
  );
};

export default HamburgerMenuContainerSkin;
